<template lang='pug'>
.views-container
  gb-side-menu
  .loading-area(v-if="fetchLoading")
    vue-loading(
      type='spin'
      color="#F7CA18"
      :size="{ width: '60px', height: '60px' }"
    )
  .content-area(v-else)
    div(style="display:flex;justify-content:space-between")
      h3 個別メッセージ
      gb-button.info(
        @clicked="toggleCreateModal(true)"
        style="width: 200px"
      ) 新規メッセージ
    .messages
      .list-row
        p.list-item.header(style="max-width: 300px;") 表示期間
        p.list-item.header 個別メッセージ
        p.list-item.header
      .hr-secondary
      .list-row(v-for="message in messages", style="margin-bottom: 16px;")
        p.list-item(style="max-width: 300px;") {{ message.startDt }} 〜 {{ message.endDt }}
        p.list-item {{ message.message }}
        p.list-item(style="max-width: 100px;")
          gb-button.info(
            v-if="message.isEnabled"
            @clicked="toggleEnableModal(true, message)"
            style="width:100px;"
          ) 表示中
          gb-button.disabled(
            v-else
            :disabled="true"
            style="width:100px;"
          ) 非表示
  transition(name="fade")
    template(v-if="isShowCreateModal")
      gb-mask(:show="true")
        .card.modal
          .cancel-box(@click="toggleCreateModal(false)")
            p.cancel-bottom ×
          div(style="width: 100%")
            label.label(
              style="display: flex; width: 340px; margin: 0 auto 3px;"
            ) 開始
            div(style="display: flex; width: 340px; margin: 0 auto;")
              datepicker(
                style="margin: 0 8px 0 0; height: 34px"
                :format="DatePickerFormat"
                :language="ja"
                @selected="selectedStartDatePicker"
              )
              v-select(
                style="width: 200px"
                name="startDtTime"
                :options="timeOptions"
                v-model="startDtTime"
              )
          div(style="width: 100%; margin-top: 16px")
            label.label(
              style="display: flex; width: 340px; margin: 0 auto 3px;"
            ) 終了
            div(style="display: flex; width: 340px; margin: 0 auto;")
              datepicker(
                style="margin: 0 8px 0 0; height: 34px"
                :format="DatePickerFormat"
                :language="ja"
                @selected="selectedEndDatePicker"
              )
              v-select(
                style="width: 200px"
                name="endDtTime"
                :options="timeOptions"
                v-model="endDtTime"
              )
          div(style="width: 100%; margin-top: 16px")
            label.label(
              style="display: flex; width: 340px; margin: 0 auto;"
            ) メッセージ
            .textarea-wrapper
              textarea.textarea(
                style="margin: 5px 0 0; padding: 3px"
                v-model='requestValue.message'
              )
          .button-wrapper(style="width: 100%; margin: 40px 0 64px; display: flex; justify-content: center")
            gb-button.info(
              @clicked="createAndUpdateMaintenanceMessage"
              :isLoading="isButtonLoading"
              style="width:300px;"
            ) 送信
  transition(name="fade")
    template(v-if="isShowEnableModal")
      gb-mask(:show="true")
        .card.modal
          .cancel-box(@click="toggleEnableModal(false, null)")
            p.cancel-bottom ×
          h3(style="text-align: center; width: 100%") 非表示にしますか？
          .button-wrapper(style="width: 100%; margin: 40px 0 64px; display: flex; justify-content: center")
            gb-button.info(
              @clicked="createAndUpdateMaintenanceMessage"
              :isLoading="isButtonLoading"
              style="width:300px;"
            ) 非表示にする
</template>

<script>
import util from '@/api/util'
import { VueLoading } from 'vue-loading-template'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbMask from '@/components/atoms/GbMask.vue'
import GbButton from '@/components/atoms/GbButton.vue'

export default {
  components: {
    VueLoading,
    Datepicker,
    GbSideMenu,
    GbMask,
    GbButton
  },
  data () {
    return {
      timeOptions: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'],
      fetchLoading: true,
      isShowCreateModal: false,
      isShowEnableModal: false,
      isButtonLoading: false,
      messages: [],
      startDt: '',
      startDtTime: '',
      endDt: '',
      endDtTime: '',
      requestValue: {
        message: '',
        start_dt: '',
        end_dt: '',
        is_enabled: true,
        method_type: ''
      },
      // vuejs-datepicker
      DatePickerFormat: 'yyyy-MM-dd',
      ja: ja
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.fetchMaintenanceMessageList()
          }
        })
    }
  },
  methods: {
    async fetchMaintenanceMessageList () {
      try {
        const APPSYNC_RESPONSE = (await util.createMethod('APPSYNC', 'fetchMaintenanceMessageList', null))
        const SPR_RESPONSE = (await util.createMethod('SPR', 'sprFetchMaintenanceMessage', {})).data.data
        let messages = APPSYNC_RESPONSE.items
        const SPR_MESSAGE = {
          startDt: SPR_RESPONSE.start_dt,
          endDt: SPR_RESPONSE.end_dt,
          message: SPR_RESPONSE.message,
          isEnabled: SPR_RESPONSE.is_enabled
        }
        messages.unshift(SPR_MESSAGE)
        this.messages = []
        this.messages = messages
        this.fetchLoading = false
      } catch (error) {}
    },
    toggleEnableModal (isOpen, message) {
      if (isOpen) {
        this.requestValue.message = message.message
        this.requestValue.start_dt = message.startDt
        this.requestValue.end_dt = message.endDt
        this.requestValue.is_enabled = !message.isEnabled // 必ずfalse
        this.requestValue.method_type = 'update'
      } else {
        this.requestValue.message = ''
        this.requestValue.start_dt = ''
        this.requestValue.end_dt = ''
        this.requestValue.is_enabled = true
        this.requestValue.method_type = ''
      }
      this.isShowEnableModal = isOpen
    },
    toggleCreateModal (isOpen) {
      if (isOpen) {
        this.requestValue.is_enabled = true
        this.requestValue.method_type = 'create'
      } else {
        this.requestValue.message = ''
        this.requestValue.start_dt = ''
        this.requestValue.end_dt = ''
        this.requestValue.is_enabled = true
        this.requestValue.method_type = ''
      }
      this.isShowCreateModal = isOpen
    },
    async selectedStartDatePicker (date) {
      this.startDt = moment(date).format('YYYY-MM-DD')
    },
    async selectedEndDatePicker (date) {
      this.endDt = moment(date).format('YYYY-MM-DD')
    },
    async createAndUpdateMaintenanceMessage () {
      if (this.requestValue.method_type === 'create') {
        if (!this.startDt || !this.startDtTime || !this.endDt || !this.endDtTime || !this.requestValue.message) {
          this.$swal.fire({
            text: `全ての項目を入力してください`
          })
          return
        }
        let start = moment(this.startDt + ' ' + this.startDtTime).format('X')
        let end = moment(this.endDt + ' ' + this.endDtTime).format('X')
        if (start > end) {
          this.$swal.fire({
            text: `開始と終了を確認してください`
          })
          return
        }
      }
      this.isButtonLoading = true
      try {
        if (this.requestValue.method_type === 'create') {
          this.requestValue.start_dt = this.startDt + ' ' + this.startDtTime
          this.requestValue.end_dt = this.endDt + ' ' + this.endDtTime
        }
        const SPR_REQUEST_VALUE = this.requestValue
        await util.createMethod('SPR', 'sprPosthMaintenanceMessage', SPR_REQUEST_VALUE)
        this.toggleCreateModal(false, null)
        this.toggleEnableModal(false, null)
        this.isButtonLoading = false
        this.fetchMaintenanceMessageList()
      } catch (error) {}
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '../stylus/main.styl'

.messages
  width 100%
  padding 32px
  background-color #ffffff
  min-height 800px
.list-row
  display flex
  flex-direction row
  align-items center
  p
    font-size 12px
.list-item
  flex 1
  color $color-secondary !important
  &.header
    font-weight 400

.card {
  padding 30px
  min-width 800px
  margin auto
  background-color #ffffff
  display flex
  justify-content center
  &.modal {
    padding 0
    flex-direction column
    align-items flex-end
  }
  .modal-text {
    width 100%
    text-align center
    margin 48px 0
  }
}

.cancel-box {
  cursor pointer
  width: 50px;
  height: 50px;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  display: grid;
  align-items: center;
  cursor pointer
  .cancel-bottom {
    font-size: 30px;
    text-align: center;
    font-weight: 300;
  }
}

.label
  font-size 12px
  color $color-secondary
  margin 0 8px

.textarea-wrapper {
  width 340px
  margin: 0 auto
  .textarea {
    width: 100%
    height 150px
    border 1px solid #B0B0C0
    outline none
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Message.vue